{
  "ru": {
    "confirmationModal": {
      "yes": "Да",
      "no": "Нет"
    }
  },
  "kk": {
    "confirmationModal": {
      "yes": "Иә",
      "no": "Жоқ"
    }
  },
  "en": {
    "confirmationModal": {
      "yes": "Yes",
      "no": "No"
    }
  }
}
